<template>
	<div class="demo-template">这是demo页面的模板</div>
</template>

<script>
export default {
	name: 'demoTemplate',
	components: {},
	props: {},
	data() {
		return {}
	},
	computed: {},
	watch: {},
	methods: {},
	created() {},
	mounted() {}
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
